"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return MCPToken;
    }
});
const _catchError = require("src/helpers/catchError");
const _nanoid = require("nanoid");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
const _extractProps = require("~/helpers/extractProps");
const _modelUtils = require("~/utils/modelUtils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let MCPToken = class MCPToken {
    static async validateToken(context, token, id, ncMeta = _Noco.default.ncMeta) {
        const mcpToken = await this.get(context, id, ncMeta);
        if (!mcpToken || token !== mcpToken.token) {
            _catchError.NcError.notFound('MCP Token not found');
        }
        return mcpToken;
    }
    static async get(context, mcpTokenId, ncMeta = _Noco.default.ncMeta) {
        const key = `${_globals.CacheScope.MCP_TOKEN}:${mcpTokenId}`;
        let mcpToken = await _NocoCache.default.get(context, key, _globals.CacheGetType.TYPE_OBJECT);
        if (!mcpToken) {
            mcpToken = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.MCP_TOKENS, mcpTokenId);
            if (mcpToken) {
                await _NocoCache.default.set(context, key, mcpToken);
            }
        }
        return mcpToken && new MCPToken(mcpToken);
    }
    static async list(context, userId, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.MCP_TOKEN, [
            context.base_id,
            userId
        ]);
        let { list: mcpTokenList } = cachedList;
        if (!cachedList.isNoneList && !mcpTokenList.length) {
            mcpTokenList = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.MCP_TOKENS, {
                condition: {
                    fk_user_id: userId
                },
                orderBy: {
                    created_at: 'asc'
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.MCP_TOKEN, [
                context.base_id,
                userId
            ], mcpTokenList, [
                'id'
            ]);
        }
        return mcpTokenList.map((mcpToken)=>{
            delete mcpToken.token;
            return new MCPToken(mcpToken);
        });
    }
    static async listByUser(context, userId, ncMeta = _Noco.default.ncMeta) {
        const mcpTokenList = await ncMeta.metaList2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.MCP_TOKENS, {
            condition: {
                fk_user_id: userId
            },
            orderBy: {
                created_at: 'asc'
            }
        });
        return mcpTokenList.map((mcpToken)=>{
            delete mcpToken.token;
            return new MCPToken(mcpToken);
        });
    }
    static async insert(context, mcpToken, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(mcpToken, [
            'title',
            'base_id',
            'fk_user_id',
            'fk_workspace_id'
        ]);
        insertObj.token = (0, _nanoid.nanoid)(32);
        insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.MCP_TOKENS, {
            base_id: context.base_id
        });
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.MCP_TOKENS, insertObj);
        return this.get(context, id, ncMeta).then(async (res)=>{
            const key = `${_globals.CacheScope.MCP_TOKEN}:${id}`;
            await _NocoCache.default.appendToList(context, _globals.CacheScope.MCP_TOKEN, [
                context.base_id,
                mcpToken.fk_user_id
            ], key);
            return res;
        });
    }
    static async update(context, mcpTokenId, mcpToken, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(mcpToken, [
            'token'
        ]);
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.MCP_TOKENS, (0, _modelUtils.prepareForDb)(updateObj), mcpTokenId);
        const key = `${_globals.CacheScope.MCP_TOKEN}:${mcpTokenId}`;
        await _NocoCache.default.update(context, key, updateObj);
        return await this.get(context, mcpTokenId, ncMeta);
    }
    static async delete(context, mcpTokenId, ncMeta = _Noco.default.ncMeta) {
        const token = await this.get(context, mcpTokenId, ncMeta);
        if (!token) return false;
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.MCP_TOKENS, mcpTokenId);
        const key = `${_globals.CacheScope.MCP_TOKEN}:${mcpTokenId}`;
        await _NocoCache.default.del(context, key);
        return true;
    }
    static async bulkDelete(params, ncMeta = _Noco.default.ncMeta) {
        const condition = (0, _extractProps.extractProps)(params, [
            'fk_workspace_id',
            'base_id',
            'fk_user_id'
        ]);
        if (!condition.fk_workspace_id && !condition.base_id && !condition.fk_user_id) {
            _catchError.NcError.badRequest('At least one of fk_workspace_id, base_id or fk_user_id is required');
        }
        const tokens = await ncMeta.metaList2(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.MCP_TOKENS, {
            condition
        });
        for (const token of tokens){
            await ncMeta.metaDelete(_globals.RootScopes.ROOT, _globals.RootScopes.ROOT, _globals.MetaTable.MCP_TOKENS, token.id);
            const key = `${_globals.CacheScope.MCP_TOKEN}:${token.id}`;
            await _NocoCache.default.del({
                workspace_id: token.fk_workspace_id,
                base_id: token.base_id
            }, key);
        }
        return true;
    }
    constructor(mcpToken){
        Object.assign(this, mcpToken);
    }
};
